// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1nMjM","name":"Header_name__Pels4","birthday":"Header_birthday__23vYs","skeleton":"Header_skeleton__1dq3z"};